import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { DifficultyMode } from '@lk/shared';

/**
 * Тільки UI-налаштування. Жодних балів, серій і прогресу:
 * усе похідне приходить із сервера, локально його «джерелом правди» не роблять.
 */
interface UiState {
  soundEnabled: boolean;
  /** Дитина може вимкнути анімації, навіть якщо система про це не просить. */
  reducedMotion: boolean;
  lastMode: DifficultyMode;
  lastLength: number;
  parentDays: number;
  toggleSound: () => void;
  setSound: (value: boolean) => void;
  toggleReducedMotion: () => void;
  setLastMode: (mode: DifficultyMode) => void;
  setLastLength: (length: number) => void;
  setParentDays: (days: number) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      soundEnabled: true,
      reducedMotion: false,
      lastMode: 'showdown',
      lastLength: 15,
      parentDays: 30,
      toggleSound: () => set((s) => ({ soundEnabled: !s.soundEnabled })),
      setSound: (value) => set({ soundEnabled: value }),
      toggleReducedMotion: () => set((s) => ({ reducedMotion: !s.reducedMotion })),
      setLastMode: (mode) => set({ lastMode: mode }),
      setLastLength: (length) => set({ lastLength: length }),
      setParentDays: (days) => set({ parentDays: days }),
    }),
    {
      name: 'lk.ui',
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
